import * as _ from 'lodash';

export const camelToDashed = s => s.replace(/[A-Z]/g, '-$&').toLowerCase();
export const spaceToDashed = s => s.replace(/ /g, '-').toLowerCase();
export const stringToDashed = s => camelToDashed(_.camelCase(s));
